import { render, staticRenderFns } from "./SolAgoraStep3.vue?vue&type=template&id=bd66166c&"
import script from "./SolAgoraStep3.vue?vue&type=script&lang=js&"
export * from "./SolAgoraStep3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports